// Local
// export const ADMIN_ENDPOINT = "http://localhost:5000/api/v1";

// Staging
export const ADMIN_ENDPOINT = "https://edu-api-vzh6.onrender.com/api/v1";

export default {
  ADMIN_ENDPOINT,
};
